import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import PocketBase from "pocketbase";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

const NewsPage = () => {
  const [newsData, setNewsData] = useState();
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNews = async () => {
      const response = await pb.collection('News').getOne(id);
      setNewsData(response);
    }
    fetchNews();
  },[id]);


  if (!newsData) return <div>Article not found</div>;

  return (
    <div className="news-article">
      <button className="back-btn" onClick={() => navigate("/")}>
        &larr; Back to News
      </button>
      <h1>{newsData.title}</h1>
      <img src={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${newsData.collectionId}/${newsData.id}/${newsData.image}`} alt={newsData.title} />
      <p className="article-content">{newsData.content}</p>
    </div>
  );
};

export default NewsPage;
